const defaultStyles = {
  padding: [5, 5, 5, 5],
  margin: [0, 'auto', 0, 'auto'],
  width: '100%',
  height: '100%'
};

export function getDefaultOptions() {

  const options = {
    ...defaultStyles,
    children: [{ text: '' }]
  };

  return options;

}